"use client";

import Link from "next/link";
import {usePathname} from "next/navigation";
import {
  Button,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import {FaChevronDown} from "@onemind-services-llc/react-icons-ng/fa";
import {TEXT_VARIANTS} from "@/theme/components/text";

type Props = {
  name: string;
  nestedRoutes: {
    isExternal?: boolean;
    name: string;
    path: string;
  }[];
  onClick?: () => void;
};

const HeaderDropdown = (props: Props) => {
  const {name, onClick, nestedRoutes} = props;
  const pathname = usePathname();
  const isActivePath = nestedRoutes.find((route) => route.path === pathname);
  return (
    <Menu>
      <MenuButton
        as={Button}
        backgroundColor={"transparent"}
        p={0}
        _active={{}}
        _focus={{}}
        _hover={{}}
      >
        <HStack alignItems="center">
          <Text
            color={isActivePath ? "primary.200" : ""}
            lineHeight={1}
            variant={TEXT_VARIANTS.BODY1}
          >
            {name}
          </Text>
          <Icon
            as={FaChevronDown}
            color={isActivePath ? "primary.200" : "gray.600"}
            fontSize="12px"
          />
        </HStack>
      </MenuButton>
      <MenuList>
        {nestedRoutes.map((route, index) => {
          return (
            <MenuItem
              as={Link}
              color={pathname === route.path ? "primary.200" : ""}
              href={route.path}
              key={index}
              onClick={onClick}
              target={route.isExternal ? "_blank" : ""}
              _hover={{color: "primary.200"}}
            >
              <Text variant={TEXT_VARIANTS.BODY2}>{route.name}</Text>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};

export default HeaderDropdown;
